// Portal-wide content protection.
//
// Disables copy / cut / paste, the right-click context menu, text selection and
// drag-selection across the whole SPA. Installed once from main.js so every
// current and future page/module inherits the behaviour automatically.
//
// Exceptions: any element (or a descendant of an element) that carries the
// `data-allow-clipboard` attribute is exempt. Use it for the documented
// exception cases — code editors, document-upload fields, administrative tools:
//
//   <div data-allow-clipboard> ...selectable / pasteable region... </div>
//
// Keep the exception list as small as possible and review additions.

const EXEMPT_ATTR = 'data-allow-clipboard';

// True when the event originates inside an explicitly exempted region.
function isExempt(target) {
    return !!(target && typeof target.closest === 'function' && target.closest(`[${EXEMPT_ATTR}]`));
}

// Blocks copy / cut / paste / contextmenu / selectstart / dragstart events.
function blockEvent(event) {
    if (isExempt(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
}

// Blocks the keyboard shortcuts Ctrl/Cmd + C / X / V.
function blockClipboardShortcuts(event) {
    if (isExempt(event.target)) return;
    if (!(event.ctrlKey || event.metaKey)) return;
    const key = (event.key || '').toLowerCase();
    if (key === 'c' || key === 'x' || key === 'v') {
        event.preventDefault();
        event.stopPropagation();
    }
}

export function installContentProtection() {
    // Capture phase so the restriction wins before any component-level handler.
    ['copy', 'cut', 'paste', 'contextmenu', 'selectstart', 'dragstart'].forEach((type) => {
        document.addEventListener(type, blockEvent, { capture: true });
    });
    document.addEventListener('keydown', blockClipboardShortcuts, { capture: true });
}
